import * as React from 'react';
import {useState} from 'react';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import {SZ_JUMBO} from "../dimens";
import {COUNTRIES, CountryType} from "../countries";

export enum CountrySelectValueType {
  CODE = "code",
  PHONE = "phone",
}

export type CountrySelectAppearance = {
  showPhone: boolean,
}

function toValue(country: CountryType, type: CountrySelectValueType): string {
  switch (type) {
    default:
    case CountrySelectValueType.CODE:
      return country?.code;
    case CountrySelectValueType.PHONE:
      return country?.phone;
  }
}

export function CountrySelect(props: {
  valueType?: CountrySelectValueType,
  value: string,
  setValue: (value: string) => void,
  allowedCountryCodes?: string[],
  appearance?: CountrySelectAppearance,
}) {
  const valueType = props.valueType || CountrySelectValueType.CODE;
  const countries = props.allowedCountryCodes ? COUNTRIES.filter(country => props.allowedCountryCodes.includes(country.code)) : COUNTRIES;
  const [currentOption, setCurrentOption] = useState<CountryType>(countries.find(country => toValue(country, valueType) === props.value));
  return <Autocomplete
    size="small"
    sx={{width: SZ_JUMBO}}
    value={currentOption}
    onChange={(event: any, newValue: CountryType) => {
      props.setValue(toValue(newValue, valueType));
      setCurrentOption(newValue);
    }}
    options={countries}
    autoHighlight
    getOptionLabel={(option) => `${option.label}${props.appearance?.showPhone ? (' +' + option.phone) : ''}`}
    renderOption={(props, option) => (
      <Box
        component="li"
        sx={{'& > img': {mr: 2, flexShrink: 0}}}
        {...props}
      >
        <img
          loading="lazy"
          width="20"
          src={`https://flagcdn.com/w20/${option.code.toLowerCase()}.png`}
          srcSet={`https://flagcdn.com/w40/${option.code.toLowerCase()}.png 2x`}
          alt=""
        />
        {option.label} ({option.code}) +{option.phone}
      </Box>
    )}
    renderInput={(params) => (
      <TextField
        {...params}
        autoComplete={"country"}
        InputProps={{
          ...params.InputProps,
          style: {background: "white", maxWidth: SZ_JUMBO, flexGrow: 1},
          autoComplete: 'new-password', // disable autocomplete and autofill
        }}
        inputProps={{
          ...params.inputProps,
        }}
      />
    )}
  />;
}